import { io, type Socket } from 'socket.io-client';

const GAME_SERVER_URL = import.meta.env.VITE_GAME_SERVER_URL ?? 'http://localhost:3002';

let socket: Socket | null = null;

export interface PresenceFlags {
  appearOnline: boolean;
  acceptChallenges: boolean;
}

export function getSocket(token: string, flags?: PresenceFlags): Socket {
  // Reuse any existing socket — connected OR mid-connection. Multiple hooks
  // (useSocket in NotificationProvider, PresenceProvider, screen components)
  // call this concurrently after their own async token fetch; tearing down an
  // in-flight socket here would thrash the connection and orphan the listeners
  // those hooks already registered (e.g. presence subscriptions). The socket is
  // only torn down explicitly on logout via disconnectSocket().
  if (socket) return socket;

  socket = io(GAME_SERVER_URL, {
    auth: {
      token,
      appearOnline: flags?.appearOnline ?? true,
      acceptChallenges: flags?.acceptChallenges ?? true,
    },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
  });

  return socket;
}

export function getExistingSocket(): Socket | null {
  return socket;
}

export function disconnectSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
